import { HeaderMenuPosition, MenuPositionData } from '../interfaces';

export const mapToBaseMenuPosition: (position: HeaderMenuPosition) => MenuPositionData = (
  position: HeaderMenuPosition
): MenuPositionData => ({
  label: position.label,
  externalUrl: position.externalUrl,
  shouldOpenInNewTab: position.shouldOpenInNewTab,
  internalPath: position.internalPath,
  action: position.action,
  icon: position.icon,
  name: position.name,
  childrenPositions: position.childrenPositions,
});
